import { useMemo } from "react"
import {
  periodFrom,
  type Period,
} from "@/v2-backoffice-client/signIn/signIn.period"
import { useStoredSharingRisksQuery } from "@/v2-backoffice-client/signIn/storedSharingRisks.query"

// useSignInSharingRisks is the Users tab's single data concern: the per-user
// sharing-risk rollup for a period, ranked worst-first. Every period recomputes
// the rollup over the durable event log (acc.UserSignInEvents) via SQL — no live
// MS Graph round-trip — so it's fast and uniform across periods. The events the
// rollup scores are already geoip-enriched at ingest by v2-auth-monitor, so
// countries / outside-EEA populate from storage.
export function useSignInSharingRisks(period: Period) {
  // Memoised on `period` because periodFrom() resolves `new Date()`: an
  // unmemoised value changes every render and drives Apollo into an infinite
  // refetch loop (the Compiler can't memoise a non-deterministic value).
  const from = useMemo(() => periodFrom(period), [period])

  const stored = useStoredSharingRisksQuery({
    variables: { input: { from } },
  })

  return {
    risks: stored.data?.getStoredSignInSharingRisks ?? [],
    loading: stored.loading,
    error: stored.error,
    refetch: stored.refetch,
  }
}
